import { Injectable } from '@angular/core';
declare let THREE: any;

@Injectable()
export class GeometryHelperService {

  constructor() { }

  box3 = new THREE.Box3();

  areaForCentroidFloor = function (points) {
    var area = 0;
    var pts = points;
    var nPts = pts.length;
    var j = nPts - 1;
    var p1; var p2;

    for (var i = 0; i < nPts; j = i++) {
      p1 = pts[i]; p2 = pts[j];
      area += p1.x * p2.y;
      area -= p1.y * p2.x;
    }
    area /= 2;

    return area;
  }

  getMeshSize(mesh) {
    var geometry = mesh.geometry;
    if (!geometry.boundingBox)
      geometry.computeBoundingBox();
    return geometry.boundingBox.getSize(new THREE.Vector3());
  }
  computeBoundingSphereFromMeshes(meshes) {
    var bb = this.objectsBoundingBox(meshes);
    return bb.getBoundingSphere();
  }
  isClockwisePolygon(points) {
    var sum = 0,
      i = 0,
      count = points.length - 1;
    for (; i < count; i++)
      sum += (points[i + 1].x - points[i].x) * (points[i + 1].y + points[i].y);
    return (sum > 0) ? true : false;
  }
  getWallCenter(wall) {
    var size = this.getMeshSize(wall),
      wallCenter = new THREE.Vector3(size.x / 2, size.y / 2, size.z / 2);
    wall.updateMatrixWorld();
    wallCenter.applyMatrix4(wall.matrixWorld);
    return wallCenter;
  }
  getPolygonCenter(vertices) {
    var pts = vertices;
    var nPts = pts.length;
    var x = 0; var y = 0;
    var f;
    var j = nPts - 1;
    var p1; var p2;

    for (var i = 0; i < nPts; j = i++) {
      p1 = pts[i]; p2 = pts[j];
      f = p1.x * p2.y - p2.x * p1.y;
      x += (p1.x + p2.x) * f;
      y += (p1.y + p2.y) * f;
    }

    f = this.areaForCentroidFloor(vertices) * 6;

    return { x: x / f, y: y / f };
  }
  getObjectsCenter(objects) {
    var points = [],
      i = 0;

    for (; i < objects.length; i++)
      points.push(objects[i].getWorldPosition(new THREE.Vector3()));

    this.box3.setFromPoints(points);

    return this.box3.getCenter();
  }
  objectsBoundingBox(objects) {
    var i = 0,
      bb,
      result;

    for (; i < objects.length; i++) {
      bb = new THREE.Box3().setFromObject(objects[i]);
      if (i === 0)
        result = bb;
      else
        result.union(bb);
    }

    return result;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/geometry-helper.service.ts